<template>
    <div class="drag-modal" :style="{width:width+'px', height:height+'px', left:x+'px', top:y+'px'}">
        <div class="header" @mousedown="moveStart">
            {{title}} <div class="close-btn" @click="close">
                <div class="fal fa-times"></div>
            </div>
        </div>
        <div class="body">
            <slot />
        </div>
    </div>
</template>
<script>
export default {

    name: 'drag-modal',
    props: {
        resizable: { type: Boolean, default: false },
        title: String,
        id: String,
        width: { type: Number, default: 320 },
        height: { type: Number, default: 440 }
    },
    mounted() {
        if (this.id && localStorage['drag-modal-' + this.id]) {
            let parsed = JSON.parse(localStorage['drag-modal-' + this.id]);
            if (parsed.x) this.x = parsed.x;
            if (parsed.y) this.y = parsed.y;
        }
    },
    methods: {
        close() {
            this.$emit('close');
        },
        onMove(e) {
            let dX = this.startMX - e.x;
            let dY = this.startMY - e.y;
            this.x = this.startX - dX;
            this.y = this.startY - dY;
            if (this.id) {
                localStorage['drag-modal-' + this.id] = JSON.stringify({ x: this.x, y: this.y });
            }
        },
        moveStart(e) {
            document.body.addEventListener('mousemove', this.onMove);
            document.body.addEventListener('mouseup', this.moveEnd);
            this.startMX = e.x;
            this.startMY = e.y;
            this.startX = this.x;
            this.startY = this.y;
        },
        moveEnd() {
            document.body.removeEventListener('mousemove', this.onMove);
            document.body.removeEventListener('mouseup', this.moveEnd);
        }
    },
    data() {
        return {
            startMX: 0,
            startMY: 0,
            startX: 0,
            startY: 0,
            x: 0,
            y: 0
        }
    }
}
</script>
<style lang="css" scoped>
.drag-modal {
    position: fixed;
    border: 1px solid lightgrey;
    border-radius: 4px;
    background: white;
}

.header {
    border-bottom: 1px solid lightgrey;
    overflow: hidden;
    padding: 4px 6px;
    cursor: move;
}

.close-btn {
    float: right;
    cursor: pointer;
}
</style>